import { jsx as _jsx } from "react/jsx-runtime";
import { GridIcon } from "@radix-ui/react-icons";
import { Button, Tooltip } from "@radix-ui/themes";
import { useEditorStore } from "../../stores";
export function StageTools() {
    const { showGrid, setShowGrid } = useEditorStore();
    return (_jsx("div", { className: "stage-tools", children: _jsx(Tooltip, { content: showGrid ? "Hide Grid (G)" : "Show Grid (G)", children: _jsx(Button, { variant: "soft", radius: "none", size: "2", onClick: () => setShowGrid(!showGrid), className: showGrid ? "active" : "", children: _jsx(GridIcon, {}) }) }) }));
}
